import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { isIosApp } from '../../utils/appPlatform';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { user } = useAuth();
  const hasPro = user?.subscriptionStatus === 'pro' || user?.subscriptionStatus === 'premium';
  const iosApp = isIosApp();

  if (iosApp) return null;

  return (
    <footer className="bg-white dark:bg-gray-900 border-t border-gray-100 dark:border-gray-800 px-6 py-4">
      <div className="flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-gray-400 dark:text-gray-500">
        <p>&copy; {currentYear} Integrative Health Journal. NutriTrack app.</p>
        <div className="flex items-center gap-4">
          <Link to="/blog" className="hover:text-gray-600 dark:hover:text-gray-300 transition-colors">Blog</Link>
          <Link to="/books" className="hover:text-gray-600 dark:hover:text-gray-300 transition-colors">Books</Link>
          <Link to="/contact" className="hover:text-gray-600 dark:hover:text-gray-300 transition-colors">Contact</Link>
          {!hasPro && (
            <Link to="/upgrade" className="hover:text-indigo-500 transition-colors font-medium">Upgrade to Pro</Link>
          )}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
